export const AVAILABILITY_UPDATED =
  '@trybeapp/screens/PractitionerAvailabilityCalendar/AVAILABILITY_UPDATED'
